module.exports = __webpack_public_path__ + "static/media/firebase.10ef412d.png";